// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.sf-rating{display:flex;--icon-color:var(--c-primary);--icon-color-negative:var(--c-gray-variant);--icon-size:0.875rem}.sf-rating__icon--negative{--icon-color:var(--icon-color-negative)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
